/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import facepaint from 'facepaint';
import * as React from 'react';
import { Trans, msg } from '@lingui/macro';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useLingui } from '@lingui/react';
import { Space } from '../Space';
import { SanityLinkContainer } from '../oblisPortableText/components/link/components';

const style: ouiStyle.InStyleWithMediaQueries = {
  color: ouiStyle.Constants.Colors.logoBlue,
  fontStyle: 'italic',
  textAlign: 'justify',
  lineFactor: 0.875,
  container: ouiStyle.Constants.Container.xl,
};

export const disclaimerCss = ouiStyle.mediaQuery(ouiStyle.makeCss(style));

export const Disclaimer = (props: {
  withBond?: boolean,
  paddingHorizontal?: ouiStyle.InStyleWithMediaQueries['paddingHorizontal'],
}) => {
  const {
    withBond = false,
    paddingHorizontal,
  } = props;
  const {
    _,
  } = useLingui();
  const css = React.useMemo(
    () => facepaint([
      '@media only screen and (min-width: 34rem)',
      '@media only screen and (min-width: 40rem)',
      '@media only screen and (min-width: 48rem)',
      '@media only screen and (min-width: 62rem)',
      '@media only screen and (min-width: 81.5rem)',
    ])(ouiStyle.makeCss({
      ...style,
      paddingHorizontal,
    })),
    [paddingHorizontal],
  );
  return (
    <div
      css={css}
    >
      <Trans>
        <p>
          La présente communication a un caractère commercial. Elle n’a pas été élaborée conformément aux dispositions légales arrêtées pour promouvoir l'indépendance de la recherche en investissements, et n'est soumise à aucune interdiction prohibant l'exécution de transactions avant la diffusion de la recherche en investissements. Pour un aperçu des frais et coûts liés aux services d'investissement offerts par Goldwasser Exchange en rapport avec l'instrument financier mentionné dans le présent article, il convient de se référer à la
          <Space />
          <SanityLinkContainer
            href={_(msg`https://d35udc6x0xtv0z.cloudfront.net/documents/tarifs.pdf`)}
          >
            grille tarifaire
          </SanityLinkContainer>
          <Space />
          de la Société.
        </p>
      </Trans>
      {
        withBond
          ? (
            <Trans>
              <p>
                Tout investissement en obligation expose l’investisseur au risque de contrepartie (incapacité de l’émetteur à payer les coupons éventuels et à rembourser le principal à l’échéance), au risque de marché (impossibilité de vendre l’obligation avant l’échéance sans subir une moins-value suite à une diminution subséquente du prix de l’obligation liée à des facteurs tels que l'augmentation des taux d'intérêt ou une dégradation de la qualité du crédit de l’émetteur) ou encore au risque d’inflation (réduction du rendement réel de l’obligation suite à une augmentation significative de l’inflation). Les obligations libellées en devises étrangères présentent en outre un risque de change.
              </p>
            </Trans>
          )
          : null
      }
    </div>
  );
};
